enum CreateExceptionsWizardContextSteps {
  "ServiceArea",
  "Specialty",
  "Project",
  "Details",
  "Attachment",
  "Review"
}

enum UploadExceptionsWizardContextSteps {
  "Upload",
  "Review"
}

interface WizardStepProps {
  pageIsValid?: (flag: boolean) => void;
}

export {
  CreateExceptionsWizardContextSteps,
  UploadExceptionsWizardContextSteps,
  WizardStepProps
}